<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs v-show="xian1">
        <!-- 过滤器列表 -->
        <el-tab-pane label>
          <span slot="label">
            {{ $t("logs.filter1") }}
          </span>
          <div class="main">
            <el-button
              @click="tan_add_filter()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.filter2") }}</el-button
            >
          </div>
          <div class="switch1">
            <div class="table table02">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="FILTER_NAME"
                  :label="$t('logs.filter3')"
                ></el-table-column>
                <el-table-column
                  prop="DESCRIBE"
                  :label="$t('logs.filter4')"
                  width="300"
                ></el-table-column>
                <el-table-column
                  prop="BY_USED"
                  :label="$t('logs.filter5')"
                ></el-table-column>
                <el-table-column
                  prop="CREATETIME"
                  :label="$t('logs.filter6')"
                ></el-table-column>
                <el-table-column
                  prop="UPDATETIME"
                  :label="$t('logs.filter7')"
                ></el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template slot-scope="scope">
                    <el-button
                      @click="handleClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="edit1(scope.$index, scope.row)"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div v-show="xian2" v-loading="loading">
        <div class="main1">
          <div class="create_information" v-if="this.xian3 == 0">
            {{ $t("logs.filter2") }}
          </div>
          <div class="create_information" v-if="this.xian3 == 1">
            {{ $t("logs.filter10") }}
          </div>
          <el-button
            type="primary"
            @click="tan_showmacro()"
            v-show="showmacro_list1"
            v-if="this.show_macro_list == 1"
            >{{ $t("logs.filter8") }}</el-button
          >
          <el-button
            type="primary"
            @click="tan_showmacro1()"
            v-show="showmacro_list"
            >{{ $t("logs.filter9") }}</el-button
          >
        </div>
        <div class="lie" v-show="showmacro_list">
          <table>
            <tbody>
              <tr v-for="v in showmacro" :key="v.id">
                <td>{{ v.MACRO_NAME }}</td>
                <td style="padding: 10px 0 10px 20px">
                  {{ v.MACRO_VALUE }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="lie">
          <table>
            <tbody>
              <tr>
                <!--  过滤器名称-->
                <td>{{ $t("logs.filter3") }}:</td>
                <td>
                  <el-input
                    v-model="filter_name"
                    placeholder
                    v-if="this.xian3 == 0"
                  ></el-input>
                  <span
                    style="text-align: left; color: #0e2c5e; line-height: 32px"
                    v-if="this.xian3 == 1"
                    >{{ this.filter_name }}</span
                  >
                </td>
              </tr>
              <tr>
                <!--  过滤器描述-->

                <td>{{ $t("logs.filter4") }}:</td>
                <td>
                  <el-input v-model="filter_describe" placeholder></el-input>
                </td>
              </tr>
            </tbody>
            <!--  启用条件策略-->

            <tbody>
              <tr>
                <!--  启用条件策略-->

                <td>{{ $t("logs.Conditional1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox
                    v-model="chkcondition"
                    @change="change"
                  ></el-checkbox>
                  <el-radio-group
                    v-model="rootcondrelation"
                    style="padding-left: 20px"
                    @change="change1"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in tiaoa" :key="v.id">
                    <ul>
                      <!--  条件块-->

                      <li>{{ $t("logs.Conditional4") }}:</li>
                      <!--  添加条件块-->

                      <li @click="tiaojian_add1" class="cursor_hover">
                        {{ $t("logs.Conditional5") }}
                      </li>
                      <!--  删除条件块-->

                      <li @click="deleteRow(v.id)" class="cursor_hover">
                        {{ $t("logs.Conditional6") }}
                      </li>
                      <li>
                        <el-radio-group
                          v-model="v.condition_relation"
                          style="padding-left: 20px"
                        >
                          <el-radio :label="1">
                            {{ $t("logs.Conditional2") }}
                          </el-radio>
                          <el-radio :label="0">
                            {{ $t("logs.Conditional3") }}
                          </el-radio>
                        </el-radio-group>
                      </li>
                    </ul>
                    <ol v-for="c in v.tiaob" :key="c.id">
                      <el-select
                        v-model="c.condition_name"
                        style="width: 150px"
                        v-show="condition_judge1(c.condition_name)"
                      >
                        <el-option
                          v-for="item in condition_namee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="c.msgsize_type"
                        style="width: 90px"
                        v-show="condition_judge2(c.condition_name)"
                      >
                        <el-option
                          v-for="item in msgsize_typee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 只有大于，没有小于-->
                      <el-select
                        v-model="c.msgsize_type"
                        style="width: 90px"
                        v-show="condition_judge_big(c.condition_name)"
                      >
                        <el-option
                          v-for="item in sublen_typee"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-model="c.msgsize"
                        style="width: 40px"
                        v-show="condition_judge3(c.condition_name)"
                      ></el-input>
                      <el-select
                        v-model="c.msgsize_unit"
                        style="width: 54px"
                        v-show="condition_judge4(c.condition_name)"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  当值为网络类型-->
                      <el-select
                        v-model="c.network_type"
                        style="width: 120px"
                        v-show="condition_judge5(c.condition_name)"
                      >
                        <el-option
                          v-for="item in network_type00"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  当值为是否为白名单-->
                      <el-select
                        v-model="c.white_type"
                        style="width: 50px"
                        v-show="condition_judge6(c.condition_name)"
                      >
                        <el-option
                          v-for="item in white_typee"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                        <!--  当值为是否为spf-->
                      <el-select
                        v-model="c.spf_result"
                        style="width: 100px"
                        v-show="condition_judge_spf(c.condition_name)"
                      >
                        <el-option
                          v-for="item in q_spf_result"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!--  添加-->

                      <li @click="tiaojian_add2(v.id)" class="cursor_hover">
                        {{ $t("logs.Conditional7") }}
                      </li>
                      <!--  删除-->

                      <li @click="deleteRow2(v.id, c.id)" class="cursor_hover">
                        {{ $t("logs.Conditional8") }}
                      </li>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>
            <!--  启用内容策略-->
            <tbody>
              <tr>
                <!--  启用内容策略-->

                <td>{{ $t("logs.Content1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox
                    v-model="chkcontent"
                    @change="change3"
                  ></el-checkbox>
                  <el-radio-group
                    v-model="rootcontrelation"
                    @change="change4"
                    style="padding-left: 20px"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in contentList" :key="v.id">
                    <ul>
                      <!--  内容块-->

                      <li>{{ $t("logs.Content2") }}:</li>
                      <!--  添加内容块-->

                      <li @click="content_add1" class="cursor_hover">
                        {{ $t("logs.Content3") }}
                      </li>
                      <!--  删除内容块-->

                      <li @click="deleteRow3(v.id)" class="cursor_hover">
                        {{ $t("logs.Content4") }}
                      </li>
                      <li>
                        <el-radio-group
                          v-model="v.content_out_relation"
                          style="padding-left: 20px"
                        >
                          <el-radio :label="1">
                            {{ $t("logs.Conditional2") }}
                          </el-radio>
                          <el-radio :label="0">
                            {{ $t("logs.Conditional3") }}
                          </el-radio>
                          <el-radio :label="2">
                            {{ $t("logs.Content5") }}
                          </el-radio>
                        </el-radio-group>
                      </li>
                    </ul>
                    <ol
                      v-for="c in v.contentList1"
                      :key="c.id"
                      class="tiaojian_a_child"
                    >
                      <div class="content_keyword_fang">
                        <el-select
                          v-model="c.content_name"
                          style="width: 100px"
                          v-show="
                            content_judge1(c.content_name, c.content_type)
                          "
                        >
                          <el-option
                            v-for="item in content_namee0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 内容策略原始信头 input-->
                        <el-input
                          v-model="c.header_key"
                          style="width: 80px"
                          v-show="
                            content_judge2(c.content_name, c.content_type)
                          "
                        ></el-input>
                        <!-- 内容策略原始信头 要求存在-->
                        <el-select
                          v-model="c.content_exist"
                          style="width: 120px"
                          v-show="
                            content_judge3(c.content_name, c.content_type)
                          "
                        >
                          <el-option
                            v-for="item in content_existt"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 包含不包含 -->
                        <el-select
                          v-model="c.content_relation"
                          style="width: 70px"
                           v-if="content_judge_keyword_or(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_relationn0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 包含不包含  关键字-->
                        <el-select
                          v-model="c.content_relation"
                          style="width: 70px"
                           v-if="content_judge_keyword(c.content_name)"
                        >
                          <el-option
                            v-for="item in content_relationn2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                         <!-- 正则表达式    关键字-->
                        <el-select v-model="c.content_type" style="width: 94px"
                          v-if="content_judge_keyword_or(c.content_name)">
                          <el-option
                            v-for="item in content_typee0"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 正则表达式 keyword  -->
                        <el-select v-model="c.content_type" style="width: 94px"
                         v-if="content_judge_keyword(c.content_name)">
                          <el-option
                            v-for="item in content_typee2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 分数 input-->
                        <el-input
                          v-model="c.score"
                          style="width: 40px"
                          v-show="content_judge_score(v.content_out_relation)"
                        >
                        </el-input>
                        <span
                          v-show="content_judge_score(v.content_out_relation)"
                          style="padding-left: 0"
                          >{{ $t("logs.point") }}</span
                        >
                        <!-- 邮件正文 多少次-->
                        <el-input
                          v-model="c.content_matchcn"
                          style="width: 40px"
                          v-show="
                            content_judge4(c.content_name, c.content_type)
                          "
                        ></el-input
                        ><span
                          v-show="
                            content_judge4(c.content_name, c.content_type)
                          "
                          style="padding-left: 0"
                          >{{ $t("logs.second_rate") }}</span
                        >
                        <!-- 内容策略ip，信封发件人，收件人  关键词，精准匹配-->
                        <el-select
                          v-model="c.content_match"
                          style="width: 120px"
                          v-show="
                            content_judge5(c.content_name, c.content_type)
                          "
                        >
                          <el-option
                            v-for="item in content_matchh"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <el-input
                          type="textarea"
                          placeholder=""
                          v-model="c.regex"
                          :autosize="{ minRows: 2, maxRows: 8 }"
                          resize="both"
                          style="width: 300px"
                        >
                        </el-input>
                        <!--  添加-->

                        <li @click="content_add2(v.id)" class="cursor_hover">
                          {{ $t("logs.Conditional7") }}
                        </li>
                        <!--  删除-->

                        <li
                          @click="deleteRow4(v.id, c.id)"
                          class="cursor_hover"
                        >
                          {{ $t("logs.Conditional8") }}
                        </li>
                      </div>
                      <div class="content_keyword_fang_select"
                      v-if="content_judge_keyword(c.content_name)" >
                    
                        <el-checkbox-group
                          v-model="  c.checkedCities"
                          @change="handleCheckedCitiesChange(c.checkedCities,c)"
                          style="
                            display: flex;
                            flex-wrap: wrap;
                            padding-bottom: 6px;
                          "
                        >
                          <el-checkbox
                            v-for="v in policy_priv"
                            :label="v.value"
                            :key="v.value"
                            class="policy_priv_role"
                            >{{ v.label }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>
            <!--  启用A链接扫描-->
            <tbody>
              <tr>
                <!--  启用A链接扫描-->

                <td>{{ $t("logs.Alink1") }}:</td>
                <td style="display: flex; flex-direction: row">
                  <el-checkbox
                    v-model="chkalink"
                    @change="change5"
                  ></el-checkbox>
                  <el-radio-group
                    v-model="alink_out_relation"
                    @change="change6"
                    style="padding-left: 20px"
                  >
                    <el-radio :label="1">
                      {{ $t("logs.Conditional2") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Conditional3") }}
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="tiaojian_a" v-for="v in alinkList" :key="v.id">
                    <ul style="padding: 10px 0">
                      <!--  内容块-->

                      <li>{{ $t("logs.Alink2") }}:</li>
                      <!--  添加内容块-->

                      <li @click="alink_add1" class="cursor_hover">
                        {{ $t("logs.Alink3") }}
                      </li>
                      <!--  删除内容块-->

                      <li @click="deleteRow5(v.id)" class="cursor_hover">
                        {{ $t("logs.Alink4") }}
                      </li>
                    </ul>
                    <ol v-for="c in v.alinkList1" :key="c.id">
                      <el-select v-model="c.alink_name" style="width: 100px">
                        <el-option
                          v-for="item in alink_namee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select v-model="c.alink_relation" style="width: 70px">
                        <el-option
                          v-for="item in alink_relationn0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>

                      <el-select v-model="c.alink_type" style="width: 94px">
                        <el-option
                          v-for="item in alink_typee0"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8 }"
                        placeholder=""
                        v-model="c.alink_regex"
                        resize="both"
                        style="width: 300px"
                      >
                      </el-input>
                      <!--  添加-->

                      <li @click="alink_add2(v.id)" class="cursor_hover">
                        {{ $t("logs.Conditional7") }}
                      </li>
                      <!--  删除-->

                      <li @click="deleteRow6(v.id, c.id)" class="cursor_hover">
                        {{ $t("logs.Conditional8") }}
                      </li>
                    </ol>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td></td>
                <td style="display: flex; flex-direction: row">
                  <el-button type="primary" @click="save_one()">{{
                    $t("tab.save")
                  }}</el-button>
                  <el-button type="danger" @click="cancel()">{{
                    $t("tab.cancel")
                  }}</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinsTest } from "../../tool/mixins.js";

export default {
  mixins: [mixinsTest],
  data() {
    return {
      show_macro_list: "",
      showmacro_list: false,
      showmacro_list1: true,
      // 自适应高度
      clientHeight: document.documentElement.clientHeight - 180 || "",
      shuju: [1],
    

      data: [],
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",
     
      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "KB",
          label: "KB",
        },
        {
          value: "MB",
          label: "MB",
        },
        {
          value: "B",
          label: "B",
        },
      ],
      checked: "",
      fileList: [],
      radio: [],
      loading: false,
      newadd: 1,
      showmacro: [],
      
    };
  },
  mounted() {
    // this.getHeight()
    //增加监听事件，窗口变化时得到高度。
    // window.addEventListener('resize', this.getHeight, false)
    // 获取浏览器可视区域高度
    // this.clientHeight = `${document.documentElement.clientHeight}` - 180 //document.body.clientWidth;
    // console.log(this.clientHeight, '窗口高度');
    // window.onresize = function temp() {
    //     this.clientHeight = `${document.documentElement.clientHeight}` - 200;
    //     console.log(this.clientHeight, '窗口高度5');

    // };
    this.getFileList();
    this.tan_showmacro2();
  },
  watch: {
    
  },
  methods: {
    handleCheckAllChange(val) {
      console.log(val);
      this.checkedCities = val ? this.policy_priv.map((ele) => ele.value) : [];

      this.isArr_priv();
    },

    handleCheckedCitiesChange(value,c) {
    
    
      console.log(value, c);
      if(c.check_show){


        console.log('到这来')
        this.$forceUpdate()

      }
       console.log(value,this.checkedCities)
     
    },
    isArr_priv() {
      this.policy_priv.forEach((value) => {
        if (this.checkedCities.includes(value.value)) {
          value.select = 1;
        } else {
          value.select = 0;
        }
      });
      console.log(this.policy_priv)
          
    },
    tan_showmacro1() {
      this.showmacro_list = false;
      this.showmacro_list1 = true;
    },
    tan_showmacro() {
      this.showmacro_list = true;
      this.showmacro_list1 = false;
    },
    tan_showmacro2() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "showmacro",
            sid: sid,
          },
        })
        .then((res) => {
        //   console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
           
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
           
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.showmacro = res.data.ret.datalist;
          }
        });
    },
    handleClick(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let filter_name = scope.FILTER_NAME;

          this.$axios
            .get("/api/adm/cgi/aspam.cgi", {
              params: {
                __mode: "del_filter",
                sid: sid,

                filter_name: filter_name,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // getHeight() {
    //     //获取浏览器高度并计算得到表格所用高度。
    //     this.clientHeight = document.documentElement.clientHeight - 160
    // },
    // changeFixed(clientHeight) { //动态修改样式
    //     console.log(clientHeight);
    //     // this.$refs.multipleTable.style.height = clientHeight + 'px';
    //     // console.log(this.$refs.multipleTable.bodyHeight, )

    // },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
  
  },
};
</script>

<style lang="less" scoped>
// IP白名单
.table02 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(5) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(6) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(7) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: left;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(5) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(6) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(7) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: left;
  }
}

.tiaojian_a {
  border: 1px solid #ddd;
  padding: 0 10px !important;
}

.tiaojian_a ul {
  display: flex;
  align-items: center;

  font-size: 12px;
  border-bottom: 1px solid #ddd;

  li {
    padding: 0 10px;
  }
}

.tiaojian_a ol {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  .content_keyword_fang {
    display: flex;
    align-items: center;
  }
  li:nth-child(4) {
    padding-left: 10px;
  }

  li {
    padding-right: 10px;
  }

  /deep/.el-input {
    font-size: 12px;
  }
}
.tiaojian_a .tiaojian_a_child {
  .el-checkbox {
    margin-right: 0px;
  }
  .el-checkbox-group {
    width: 100%;
    margin: 2px 0;
  }
  .policy_priv_role {
    width: 15%;
  }
  flex-direction: column;
  align-items: flex-start;
  .content_keyword_fang {
    margin-bottom: 0px;
  }
  .content_keyword_fang_select {
    margin: 0;
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
}
/deep/ .el-radio__label {
  font-size: 12px;
}

/deep/ .el-select {
  display: flex;
  justify-content: center;
}

// 添加
.add1 {
  display: flex;
  align-items: center;
  font-size: 12px;
}

// input 框高度
/deep/ .el-input__inner {
  height: 26px;
  padding: 0 5px;
}

// .lie table {
//     width: 100%;
// }

.lie tbody {
  // width: 100%;
  display: flex;
  flex-direction: column;
  margin: 15px;

  tr {
    border: 1px solid #ddd;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-bottom: -1px;
    display: flex;
    align-items: center;
  }
}

/deep/ .el-alert__content {
  padding: 0;
}

.lie tbody td {
  font-size: 12px;
  height: 100%;
}

.lie tbody td:nth-child(1) {
  width: 100px;

  text-align: right;
  padding-right: 20px;
}

.lie tbody td:nth-child(2) {
  display: flex;
  border-left: 1px solid #ddd;

  flex-direction: column;

  .el-input {
    width: 200px;
  }

  padding-left: 20px;

  div {
    padding: 2px 4px;
    margin: 5px 0;
  }
}

// /deep/ .el-tabs__header {
//     margin: 0;
// }

// /deep/ .el-tabs__content {
//     padding: 0;
// }

.el-button {
  padding: 6px;
}

.find2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //   height: 300px;
  padding-top: 30px;
  padding-left: 30px;
  width: 50%;
  margin-bottom: 20px;
}

.find2-1 {
  width: 100%;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  //   justify-content: center;

  div {
    padding: 0 5px;
  }
}

.find2-1 .find-text {
  font-size: 14px;
}

.find2-1 .el-row {
  margin-left: 140px;
}

// 弹出框1
// 一行
.find {
  display: flex;
  //   flex: 1;
  overflow: auto;
  flex-direction: column;
  text-align: left;
  background: #f1f1f1;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 40px 0;
  width: 80%;

  p {
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}

.find1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
}

// 文字
.find-text {
  padding: 0 20px;
  font-size: 12px;
}

.pop-up {
  position: fixed;
  padding: 20px 0;
  width: 50%;
  //   height: 80%;
  top: 10%;
  left: 25%;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}

.gray {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: 0.6;
  z-index: 100;
}

.table span {
  font-size: 14px;
}

// 时间
.time {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  background: #f1f1f1;
  margin: 10px 0;
}

.time1 {
  display: flex;
  align-items: center;
  padding: 2px 0 2px 14px;
  font-size: 14px;
}

// 手动设置
.time-text1 {
  padding-left: 20px;
}

// 后台管理控制
.back {
  display: flex;
  font-size: 14px;
  line-height: 30px;
  align-items: center;
  padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
  margin: 0 10px;
}

.backText {
  text-align: right;
}

.backText1 {
  color: #999;
  font-size: 12px;
}

.back .el-input {
  width: 20%;
  padding: 0;
}

.time2 {
  display: flex;
  margin-left: 190px;
  margin-top: 10px;
}

.time2 .el-button {
  padding: 8px 24px;
  // margin: 10px ;
}

// License
.time3 {
  display: flex;
  align-items: center;
  // margin-left: 150px;
  font-size: 14px;
  padding: 4px 10px;
}

// selece
.selece1 {
  width: 130px;
}

// input 框
.back1 .input1 {
  width: 100px;
  margin: 0 10px;
}

// 单选框
.check1 {
  margin: 0 10px;
}

.backText2 {
  margin-left: 40px;
}

.backText3 {
  margin-left: 30px;
}

.back1 .input5-1 {
  width: 100px;
}

// background: #424F63;
// /deep/ .el-tabs__item .is-top {
//     font-size: 12px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
//     padding-left: 20px;
//     border-left: 0px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
//     padding-right: 20px;
// }

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
  padding-left: 16px;
}

// .el-table ::-webkit-scrollbar {
//   width: 0px;
//   background: none;
// }

.main {
  padding: 0;
}

/deep/ .el-checkbox {
  display: flex;
  align-items: center;
  // line-height: 36px;
}

.main1 {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #dcdfe6;
  // line-height: 34px;
  height: 46px;
  // background: #f1f1f1;
  // margin: 0 14px 14px 14px;
  text-align: left;

  .el-button {
    margin-left: 15px;
    padding: 8px;
  }
}
.cursor_hover:hover {
  cursor: pointer;
}
.create_information {
  padding-top: 6px;
  text-align: left;
  // padding-left: 14px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0e2c5e;
  // background: #ffffff;
  // border: 2px solid #d2d7e6;
  border-bottom: 0;
  line-height: 30px;
  padding-left: 14px;
  // margin: 0 0px 0px 14px;
}
</style>
